import React from 'react';

function Checklist() {
  const checklistItems = [
    { processo: 'Abertura de loja', status: 'Concluído' },
    { processo: 'Fechamento de caixa', status: 'Pendente' },
  ];

  return (
    <div>
      <h2>Checklist</h2>
      <ul>
        {checklistItems.map((item, index) => (
          <li key={index}>
            {item.processo}: {item.status}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Checklist;
